import { proxy, useSnapshot } from 'valtio'
import { subscribeKey } from 'valtio/utils'
import { options, watchValue } from './optionsStorage'

export const currentScaling = proxy({
  scale: 1,
})
window.currentScaling = currentScaling

const setScale = () => {
  currentScaling.scale = options.guiScale * 0.7
}

const setUiScale = () => {
  // Replicates CSS clamp(0.72, calc(1vmin / 14.4px), 1.6) reliably.
  // Also calculate --ui-scale for Replay UI which responds continuously
  // to viewport size rather than stepping.
  // We clamp it so it never gets absurdly huge or impossibly tiny.
  const vminPx = Math.min(window.innerWidth, window.innerHeight) / 100
  const s = Math.max(0.72, Math.min(1.6, vminPx / 14.4))
  document.documentElement.style.setProperty('--ui-scale', String(s))
}


setScale()
setUiScale()
subscribeKey(options, 'guiScale', setScale)
watchValue(currentScaling, (c) => {
  document.documentElement.style.setProperty('--guiScale', String(c.scale))
  document.documentElement.style.setProperty('--scale', String(c.scale))
})
window.addEventListener('resize', () => { setScale(); setUiScale() })

export const useAppScale = () => {
  return useSnapshot(currentScaling).scale
}
